import { render, staticRenderFns } from "./Home_old.vue?vue&type=template&id=0e48af38&scoped=true"
import script from "./Home_old.vue?vue&type=script&lang=js"
export * from "./Home_old.vue?vue&type=script&lang=js"
import style0 from "./Home_old.vue?vue&type=style&index=0&id=0e48af38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e48af38",
  null
  
)

export default component.exports